module.exports = __webpack_public_path__ + "static/10-63dc566eb896fb68b6eba75930480c07.jpg";